import React, { useEffect, useState } from 'react';
import { Section } from '../Section';
import styled from 'styled-components';
import { Container } from '../Container';
import { CooperationTeam } from '../CooperationTeam';
import { ProjectSectionProps } from '../../model/ProjectSection';
import { OurTeam } from '../OurTeam';
import { useTranslation } from 'react-i18next';
import { getOurTeam } from '../../services/getOurTeam';
import { teamMembers } from '../../config/teamConfig';
import { t } from '../../../i18n';
import { RawTeamMember } from '../../model/TeamMember';
import { buildTeam } from '../../helpers/buildTeam';

export const Teams = (props: ProjectSectionProps) => {
  const { i18n } = useTranslation();
  const [fetched, setFetched] = useState<RawTeamMember[]>([]);

  useEffect(() => {
    const existingKeys = teamMembers.map((m) => m.key);
    getOurTeam(existingKeys)
      .then((data) => setFetched(data))
      .catch(console.error);
  }, []);

  // until other languages are added to the about repo, fallback to english
  const lang = i18n.language.startsWith('cs') ? 'cs' : 'en';
  const ourTeam = buildTeam('mildblue', fetched, lang);
  const coopTeam = buildTeam('cooperation', fetched, lang);

  return (
    <Section id="teams" inverse={props.inverse} heading={t('section.teams')}>
      <Container>
        <TeamContainer>
          <OurTeam team={ourTeam} />
          <CooperationTeam team={coopTeam} />
        </TeamContainer>
      </Container>
    </Section>
  );
};

const TeamContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  h3 {
    text-align: center;
  }
`;
